import { useEffect, useState } from "react";

import { SVG_MAP } from "utils";
import { IReaction } from "MVVM/@types";

const useReactions = (reactions: IReaction[]) => {
  const [reactionsState, setReactionsState] = useState(reactions || []);
  const findTopReaction = (reactions: IReaction[]): IReaction => {
    if (!reactions || reactions.length === 0) {
      return { type: "FIRE", count: 0 };
    }

    return reactions.reduce(
      (max, reaction) => (reaction.count > max.count ? reaction : max),
      reactions[0],
    );
  };
  const [topReaction, setTopReaction] = useState(findTopReaction(reactions));

  const optimisticReactionUpdate = (type: keyof typeof SVG_MAP) => {
    if (!reactionsState || reactionsState.length === 0) {
      // If no reactions exist, create a new one with count 1
      const newReaction = { type, count: 1 };
      return setReactionsState([newReaction]);
    }

    const reactionsMapped = reactionsState.map((reaction) => {
      if (reaction.type === type) {
        const copy = { ...reaction };
        copy.count++;
        return copy;
      }

      return reaction;
    });

    return setReactionsState(reactionsMapped);
  };

  useEffect(() => {
    setTopReaction(findTopReaction(reactionsState));
  }, [reactionsState]);

  return { reactions: reactionsState, optimisticReactionUpdate, topReaction };
};

export { useReactions };
